export default __webpack_public_path__ + "static/timberline-l-series-26-cylind-19g-19g-tanks-9674ee025e74856983291712a46a9407.jpg";